/* eslint-disable import/first */
import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Star from '../../components/Star';
import ratePlease from './images/ratePlease.svg';
import rating from './images/rating.svg';
import css from './index.module.scss';
import classNames from 'classnames';

const rateIndex = ['1', '2', '3', '4', '5'];
const activeStar = {
  fill: '#ec002d',
};

const defaultStar = {
  fill: '#ffffff',
  outline: '#000000',
};

const StarRating = ({
  submitStarRating,
  smileIndex = 0,
  showInline,
  isDesktop = false,
  isFutureOrder = false,
}) => {
  const [gradeIndex, setGradeIndex] = useState(-1);
  return (
    <Grid className={classNames(css.feedbackArea, { [css.noMarginBottom]: showInline })}>
      {!showInline && (
        <Grid className={css.ratingHeader}>
          <Grid>
            <img src={ratePlease} width="19" alt="star-img" />
          </Grid>
          <Typography>
            <FormattedMessage id="pleaseRateUs" defaultMessage="Rate Us" />
          </Typography>
        </Grid>
      )}
      <Grid className={css.feedbackContainer} style={{ textAlign: 'center' }}>
        {!isDesktop && isFutureOrder && (
          <figure>
            <img src={rating} alt="Rating" />
          </figure>
        )}
        {rateIndex.map((each, index) => {
          return (
            <Star
              index={index}
              key={each}
              changeGradeIndex={() => setGradeIndex(index)}
              changeSmileIndex={() => submitStarRating(index)}
              type={gradeIndex >= index || index < smileIndex ? 'active' : 'default'}
              style={gradeIndex >= index || index < smileIndex ? activeStar : {}}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};

export default StarRating;
